import React from "react";
import { Column, Table, styles as ui } from "stories/Admin";
import styles from "../MawaqeetPushPage.module.scss";

interface Notification {
  id: number;
  title: string;
  body: string;
  date: string;
}

interface NotificationListProps {
  notifications: Notification[];
}

const pad = (n: number) => n.toString().padStart(2, "0");

const NotificationList: React.FC<NotificationListProps> = ({
  notifications,
}) => {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const columns: Array<Column<Notification>> = [
    {
      key: "title",
      header: "Tittel",
      width: 150,
      render: (n) => <b>{n.title}</b>,
    },
    {
      key: "body",
      header: "Melding",
      render: (n) => <span className={styles.body}>{n.body}</span>,
    },
    {
      key: "date",
      header: "Sendt",
      width: 150,
      numeric: true,
      render: (n) => <span className={ui.help}>{formatDate(n.date)}</span>,
    },
  ];

  return (
    <Table
      columns={columns}
      rows={notifications}
      rowKey={(n) => n.id}
      caption="Sendte meldinger"
    />
  );
};

export default NotificationList;
